<div class="chat-payment" [class.chat-payment--locked]="locked">
  @if (showLabel) {
    <div class="chat-payment__label">
      <span i18n="@@chatPaymentMethodLabel">Payment method</span
      >{{ productName ? ' for ' + productName : '' }}
      <span class="chat-payment__required" aria-hidden="true">*</span>
    </div>
  }

  @if (locked && chosenSummary) {
    <div class="chat-payment__chosen">{{ chosenSummary }}</div>
  }

  <label class="chat-payment__field-wrap">
    <span class="chat-payment__field-label">
      <span i18n="@@chatPaymentMethodFieldLabel">Payment method</span
      >{{ productName ? ' for ' + productName : '' }}
    </span>
    <select [disabled]="locked" [(ngModel)]="selectedId">
      <option value="" i18n="@@chatPaymentMethodSelectPlaceholder">Select a payment method…</option>
      @for (choice of choices; track choice.id) {
        <option [value]="choice.id">{{ choice.name }}</option>
      }
    </select>
  </label>

  @if (!locked && isAddingNewCard) {
    <label class="chat-payment__field-wrap">
      <span class="chat-payment__field-label" i18n="@@chatPaymentMethodCardLabel">Card label</span>
      <input
        type="text"
        [disabled]="locked"
        [(ngModel)]="cardLabel"
        placeholder="e.g. My Visa"
        i18n-placeholder="@@chatPaymentMethodCardLabelPlaceholder"
        aria-label="Card label"
        i18n-aria-label="@@chatPaymentMethodCardLabelAria"
      />
    </label>
  }

  <div class="chat-payment__actions">
    @if (selectedId === 'apexx_add_new') {
      <button
        type="button"
        class="chat-payment__continue"
        [disabled]="locked || !isValid"
        (click)="onContinue()"
        i18n="@@chatPaymentMethodAddCard"
      >
        Add card
      </button>
    } @else {
      <button
        type="button"
        class="chat-payment__continue"
        [disabled]="locked || !isValid"
        (click)="onContinue()"
        i18n="@@chatPaymentMethodContinue"
      >
        Continue
      </button>
    }
  </div>
</div>
